<template>
   <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item
      v-for="(bread, index) in levelList"
      :key="index"
      :to="bread.path"
    >{{ bread.title }}</el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
    export default {
        components: {
          levelList: null
        },
        data(){
           return{

           }
        },
        watch: {
          $route(route) {
            console.log("跳转");
            // this.getBreadData()
          },
          // "$route.path": function() {
          //   console.log("跳转");
          //   this.getBreadData()
          // }
        },
        created(){
            this.getBreadData()
        },
        mounted() {

        },
        methods:{
           getBreadData() {
              const meatched = this.$route.matched;
              const filterArr = meatched.filter(item => {
                return item.meta && item.meta.title;
              });

              const newBread = filterArr.map(item => {
                return {
                  title: item.meta.title,
                  path: item.path
                };
              });
			  
			  newBread[0].path = '/allcontent';
			  newBread.forEach((item,index)=>{
				  if(item.title == '发票详情'){
				  		newBread.splice(index,1);		  
				  }
			  })
              this.levelList = newBread;
              // console.log(this.levelList,'22');

          },
        }
    }
</script>

<style scoped>
    .el-breadcrumb{margin-top: 16px;}
    /deep/.el-breadcrumb__inner.is-link{
        color: #999999;font-size: 14px;font-weight: normal;
    }
    /deep/.el-breadcrumb__item:last-child .el-breadcrumb__inner{
        color: #2D2D2E;font-size: 14px;
    }
    /deep/.el-breadcrumb__item{
        float: none;
    }
    /deep/.el-breadcrumb__inner{color:#999999;font-size:14px;}
</style>
